import { render, staticRenderFns } from "./PeriodoPagoCRUD.vue?vue&type=template&id=db0497be"
import script from "./PeriodoPagoCRUD.vue?vue&type=script&lang=js"
export * from "./PeriodoPagoCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports